import { render, staticRenderFns } from "./user-images.vue?vue&type=template&id=48d1db45&scoped=true&"
import script from "./user-images.vue?vue&type=script&lang=js&"
export * from "./user-images.vue?vue&type=script&lang=js&"
import style0 from "./user-images.vue?vue&type=style&index=0&id=48d1db45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1db45",
  null
  
)

export default component.exports